import { RefObject, useEffect, useRef } from 'react';
import { scrollBookingIntoView } from '../utils/scrollBookingIntoView';

/**
 * After the booking step changes, scroll the booking anchor into view
 * (skips the initial mount so deep-links / drafts are not jumped).
 */
export function useScrollOnStepChange(
  step: unknown,
  anchorRef: RefObject<HTMLElement | null>
): void {
  const isFirstRender = useRef(true);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    scrollBookingIntoView(anchorRef.current);
  }, [step, anchorRef]);
}
